<template>
  <v-list>
    <v-list-tile class="list-header">
      <v-subheader
        class="list-subheader grey--text text--darken-3"
        :class="{clickable: showExpander}"
        @click="showExpander ? toggleExpanded() : null"
      >
        <v-layout
          wrap
          justify-center
          align-center
        >
          <v-spacer v-if="!disableSpacers" />
          {{ label }}<slot name="label-suffix" />
          <v-spacer v-if="!disableSpacers" />
          <v-btn
            v-if="showExpander"
            icon
            class="expander grey--text text--darken-3"
            @click.stop="toggleExpanded()"
          >
            <v-icon
              v-if="!expanded"
              medium
            >
              keyboard_arrow_down
            </v-icon>
            <v-icon
              v-else
              medium
            >
              keyboard_arrow_up
            </v-icon>
          </v-btn>
        </v-layout>
      </v-subheader>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'ListHeader',
  props: {
    label: {
      type: String,
      required: true,
    },
    showExpander: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    /* Spacers can cause wrong content wrapping, so allow disabling them. */
    disableSpacers: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleExpanded() {
      this.$emit('update:expanded', !this.expanded);
    },
  },
};
</script>

<style>
/* Make sure we pipe full-width through so that the v-spacers can do
 * their job.
 */
.list-header > .v-list__tile {
  width: 100%;
}
</style>

<style scoped>
/* Horizontal divider rules across device sizes. */
.list-header {
  margin: 0;
  padding: 0;
  width: calc(100% + 36px + 16px);
  background-color: rgba(0, 0, 0, 0.05);
  position: relative;
  left: -36px;
  display: flex;
  justify-content: center;
}
@media (max-width: 599px) {
  .list-header {
    left: -24px;
    width: calc(100% + 24px + 24px);
  }
}
.list-subheader {
  width: 100%;
  font-size: 14px !important;
}

.expander {
  width: 24px;
  height: 28px;
  margin-right: 0px;
}
@media (max-width: 599px) {
  .expander {
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ListHeader.vue